// Canais que NAO suportam disparo ativo (campanha / agendamento / automacao).
//
// Campanhas, agendamentos e automacoes foram construidos sobre telefone + sessao do
// WhatsApp. Instagram Direct e Facebook Messenger so permitem RESPONDER dentro de uma
// conversa ja iniciada pelo cliente (e usam PSID/IGSID, nao telefone); o webchat so
// existe enquanto o visitante esta na pagina.
//
// Lista de BLOQUEIO de proposito, nao de permissao: plataformas novas nascem
// permitidas e o canal legado "wpp_business" (grafia antiga, ainda em uso por um
// cliente) continua funcionando sem precisar de migracao de dados.
//
// Nada aqui afeta o ATENDIMENTO: responder um chat de Instagram/Messenger/webchat
// pelo painel segue normal. Isto vale apenas para disparo ativo.
// O Telegram entra na lista pelo mesmo motivo: um bot so consegue enviar para
// quem ja iniciou conversa com ele — disparo em massa voltaria 403 do provedor.
// O Mercado Livre idem: so responde pergunta de anuncio ou mensagem dentro de uma
// venda existente. Estando aqui, `formatarCanaisParaSelect` ja o desabilita nos 14
// cards de automacao, no wizard de campanhas e no drawer de agendamentos.
export const CANAIS_SEM_DISPARO = ['instagram', 'messenger', 'webchat', 'telegram', 'mercado_livre'];

// Campanhas so disparam por WhatsApp (legado ou Business). Allowlist explicita:
// diferente de `canalPodeDisparar`, que so bloqueia plataformas conhecidas sem disparo.
export const CANAIS_ELEGIVEIS_CAMPANHA = ['whatsapp', 'whatsapp_business'];

export const canalPodeDisparar = (platform) => !CANAIS_SEM_DISPARO.includes(platform);

export const canalElegivelCampanha = (platform) => CANAIS_ELEGIVEIS_CAMPANHA.includes(platform);

export const filtrarCanaisCampanha = (canais) =>
    (canais || []).filter((canal) => canalElegivelCampanha(canal.platform));

export const motivoBloqueioDisparo = (platform) => {
    if (platform === 'webchat') {
        return 'O webchat só responde conversas iniciadas pelo visitante — não é possível disparar por ele.';
    }
    if (platform === 'telegram') {
        return 'O bot do Telegram só pode enviar mensagens para quem já iniciou uma conversa com ele — não é possível disparar por ele.';
    }
    if (platform === 'mercado_livre') {
        return 'O Mercado Livre só permite responder perguntas de anúncio e mensagens dentro de uma venda já existente — não é possível disparar por ele.';
    }
    return 'Instagram e Messenger não permitem envio ativo — só é possível responder dentro de uma conversa iniciada pelo cliente.';
};

// Rotulo curto usado ao lado do nome do canal nos seletores.
export const ROTULO_SEM_DISPARO = 'não permite disparo';

/**
 * Formata a lista de canais para os seletores das automacoes.
 * Centraliza o `canais?.map(...)` que estava copiado identico em 14 cards de acao,
 * agora tambem marcando quais opcoes ficam desabilitadas.
 *
 * @param canais lista vinda de actionListaCanaisPorCliente
 * @param opcoes.usarCanalId `true` usa `canal._id` como value (CardResumoConversa);
 *                           o padrao e `cliente_id || clienteId`, usado pelos demais.
 */
export const formatarCanaisParaSelect = (canais, { usarCanalId = false } = {}) =>
    canais?.map((canal) => {
        const bloqueado = !canalPodeDisparar(canal.platform);
        return {
            value: usarCanalId ? canal._id : canal.cliente_id || canal.clienteId,
            label: bloqueado ? `${canal.nome} (${ROTULO_SEM_DISPARO})` : canal.nome,
            disabled: bloqueado,
            motivo: bloqueado ? motivoBloqueioDisparo(canal.platform) : undefined,
        };
    });
